export const DS_FLAG_CLASSES = {
  Base: "ds-flag",
};
